import React from "react";
import { Box } from "rebass";
import Text from "./Text";
import styled from "styled-components";

const Wrapper = styled(Box)`
  &:not(:lang(ar)) {
    padding-left: 32px;
    border-left: 1px solid ${(props) => props.theme.colors.violet};
  }
  &:lang(ar) {
    padding-right: 32px;
    border-right: 1px solid ${(props) => props.theme.colors.violet};
  }
`;

Wrapper.defaultProps = {
  is: "figure",
  mx: [0, 7],
  my: [5, 7],
};

const Quote = styled(Text)`
  font-weight: 400;
  color: ${(props) => props.theme.colors.violet};
  color: ${(props) => props.theme.colors.grey[0]};
  line-height: 1.25;

  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

Quote.defaultProps = {
  is: "blockquote",
  fontSize: [4, 5],
};

const Attribution = styled(Text)`
  margin-top: 16px;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.grey[0]};
  line-height: 1.5;

  &:before {
    content: ${(props) => (props.attribution ? "— " : "")};
  }

  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

Attribution.defaultProps = {
  is: "figcaption",
};

const BlockQuote = (props) => (
  <Wrapper>
    <Quote children={props.quote} />
    <Attribution children={props.attribution} />
  </Wrapper>
);

BlockQuote.defaultProps = {};

export default BlockQuote;



// WEBPACK FOOTER //
// ./src/components/BlockQuote.js